import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  update: { updating: false, success: false },
  data: [],
  loading: false,
  error: null,
};
const driverSlice = createSlice({
  name: "driverdetails",
  initialState,
  reducers: {
    fetchDriverListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDriverListSuccess(state, action) {
      state.data = action.payload.data;
      state.loading = false;
    },
    fetchDriverListFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const {
  fetchDriverListRequest,
  fetchDriverListSuccess,
  fetchDriverListFailure,
} = driverSlice.actions;
export default driverSlice.reducer;
